import { UseFormReturn } from 'react-hook-form';
import { IuserInfo } from 'reducer/common/userInfo';
import { IlogRecordQuery } from 'view/Layout/Project/components/LogRecordModal/type';
import {
  IretailerSetupRcv,
  RcvQueryForm,
  RcvQueryFormDetail,
} from '../../init';

export interface ResultSecionProps {
  _logRecordData: [
    IlogRecordQuery[],
    React.Dispatch<React.SetStateAction<IlogRecordQuery[]>>,
  ];

  _retailerSetup: [
    IretailerSetupRcv,
    React.Dispatch<React.SetStateAction<IretailerSetupRcv>>,
  ];
  _showLogRecordModal: [boolean, React.Dispatch<React.SetStateAction<boolean>>];

  formReturnDetail: UseFormReturn<RcvQueryFormDetail>;
  userInfoReducer: IuserInfo;

  handleSearch: (
    page?: number,
    pageSize?: number,
    doLoading?: boolean,
  ) => (input: RcvQueryFormDetail | RcvQueryForm) => Promise<void>;
}

export interface IlogRecordQueryRequest {
  retailerId: string;
  actionType: string;
  docType: string;
  docNo: string;
  docSeqNo: string;
}
export interface IlogRecordQueryResponse {
  contents: IlogRecordQuery[];
}

export interface IreceiveDownloadPreviewRequest {
  retailerId: string;
  receiveSeqNos: string[];
  sort: {
    desc: string;
    property: string;
  }[];
  previewShowPrice: boolean;
  downloadShowPrice: boolean;
}

export enum ReceiveDownloadPreviewRequest {
  retailerId = 'retailerId',
  userRole = 'userRole',
  receiveSeqNos = 'receiveSeqNos',
  sort = 'sort',
  previewShowPrice = 'previewShowPrice',
  downloadShowPrice = 'downloadShowPrice',
}
